// React Imports
import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Tooltip
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import VisibilityIcon from '@mui/icons-material/Visibility';

// App Imports
import {
    advance,
    advanceContract,
    createNewContract,
    getQueueC
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import {updateExistingExpressions} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeWorkSubmitting} from "../../Work/workSubmittingSlice";

import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';

import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import IconButton from "@mui/material/IconButton";





// main function
export default function ContractBigAddButtonPanel() {

    const selectorFirstTimeSetup = useSelector((state) => state.workQueueSlc.value.firstTimeSetup);

    // ****************** BEGIN STATES ****************************

    const [confirmOpen, setConfirmOpen] = React.useState(false);

    // ****************** END STATES ****************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch() ;

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN USER ****************************

    const currentUserId = localStorage.getItem('userId');
    const currentUserName = localStorage.getItem('userName');
    const currentUserDepartment = localStorage.getItem('department');

    // ****************** END USER ****************************


    // ***************** BEGIN CONTROLS ***************************

    const handleConfirmShowMe = () => {
        setConfirmOpen(false);
        console.log('New Contract Generation Initiated');
        console.log('current user id', currentUserId);
        console.log('current user name', currentUserName);
        console.log('current user department', currentUserDepartment);
        console.log('user setup experience = Show Me');
        console.log("firstTimeSetup = ", selectorFirstTimeSetup);
        // dispatchData(changeWorkSubmitting({submitting: true }));
        createNewContract(currentUserId, currentUserName, currentUserDepartment)

            .then(data => {
                dispatchData(changeWorkQueue({
                    selectedContractId: data,
                    selectedContractStatus: "NEW",
                    selectedContractDisplayFolders: false,
                    cId: data,
                    workQueueExperience: "ShowMe",
                    // firstTimeSetup: true,
                    selectedContractSectionId: 0,
                    bigAddButtonDisplay: false,
                    contractFoldersDisplay: false
                }));
                 console.log('This is my newly generated contract id', data);
                // console.log(data);
                dispatchData(changeWorkSubmitting({submitting: true }));
                console.log('advanceContract triggered for this contract id', data);
                // advance(null, true, localStorage.getItem('userName'), null, data, 'Setup')
                advanceContract(data)
                    .then(() => {
                    console.log("Advance Contract: ",data );

                })
                    .then(() => {
                        updateExistingExpressions(data);
                        // dispatchData(changeWorkSubmitting({submitting: true }));
                    })
                    .then(() => {
                                dispatchData(changeWorkQueue({firstTimeSetup: true,
                                    workQueueCSGridRefresh: true, workQueueCDPGridRefresh: true}));
                                // dispatchData(changeWorkSubmitting({submitting: false }));
                    });
                    // .then(() => {
                    //     getQueueC()
                    //
                    //         .then(data => {
                    //             console.log("get Queue C: ",data );
                    //             // dispatchData(changeWorkSubmitting({submitting: false }));
                    //             dispatchData(changeWorkQueue({firstTimeSetup: true,
                    //                 workQueueCSGridRefresh: true, workQueueCDPGridRefresh: true}));
                    //             // dispatchData(changeWorkSubmitting({submitting: false }));
                    //         })
                    // });
            })};



    const handleDialogueOpen = () => {
        setConfirmOpen(true);
    };

    const handleDialogueClose = () => {
        setConfirmOpen(false);
    };

    const handleConfirmFriendly = () => {
        setConfirmOpen(false);
        console.log("Friendly setup experience selected");
        console.log('New Contract Generation Initiated');
        console.log('current user id', currentUserId);
        console.log('current user name', currentUserName);
        console.log('current user department', currentUserDepartment);
        console.log('user setup experience = Friendly');
        // dispatchData(changeWorkQueue({
        //   workQueueExperience: "Friendly"
        // }));
        dispatchData(changeWorkSubmitting({submitting: true }));
        console.log('createNewContract Initiated');
        dispatchData(changeWorkQueue({
             workQueueExperience: "Friendly",
            bigAddButtonDisplay: false
        }));
        createNewContract(currentUserId, currentUserName, currentUserDepartment)

            .then(data => {
                dispatchData(changeWorkQueue({
                    // workQueueExperience: "Friendly",
                    selectedContractId: data,
                    selectedContractStatus: "NEW",
                    selectedContractDisplayFolders: false,
                    selectedContractSectionId: 0,
                    workQueueCdpPanelRefresh: true,
                    contractFoldersDisplay: false
                }));
                console.log('This is my newly generated contract id', data);
                // console.log(data);
                dispatchData(changeWorkSubmitting({submitting: true }));
                console.log('advanceContract triggered for this contract id', data);
                advanceContract(data).then(() => {
                    // callback(fetchWorkQueueCDP);
                    // dispatchData(changeWorkQueue({workQueueAdvanceState: true}));
                    console.log("Advance Contract: ",data );
                    // console.log(selectorContractId);
                })
                    .then(() => {
                        updateExistingExpressions(data);
                        dispatchData(changeWorkSubmitting({submitting: true }));
                        dispatchData(changeWorkQueue({firstTimeSetup: true,
                            cId: data, workQueueCdpPanelRefresh: true
                        }));
                    })

            })};


    // *************** END CONTROLS *******************************


    // ****************** BEGIN RETURN ****************************

    return (
        <Stack direction={"row"} spacing={2}>
            <Box sx={{flexGrow: 1}}/>
        <Box>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <Tooltip title={"Click to add contract from scratch"}>
                <AddCircleOutlineIcon
                    sx={{pl: 1, ml: 4, mr: 3, mb: .5, verticalAlign: 'bottom'}}
                    fontSize="large" color={'primary'}
                    aria-haspopup="true"
                    aria-controls="ringtone-menu"
                    aria-label="phone ringtone"
                    onClick={handleDialogueOpen}/>
            </Tooltip>
            <h3>Add Contract</h3>

            <Dialog open={confirmOpen} onClose={handleDialogueClose}>
                <DialogTitle>Choose Experience</DialogTitle>
                <Stack direction={"row"} spacing={0}>
                <DialogActions>
                    <IconButton  onClick={handleConfirmFriendly} color="primary">
                        <SentimentSatisfiedAltIcon/>
                    </IconButton>
                </DialogActions>
                <DialogContent>
                    <DialogContentText  color="primary"    style={{cursor:'pointer'}}  onClick={handleConfirmFriendly} >
                        Friendly
                    </DialogContentText>
                </DialogContent>
                </Stack>
                <Stack direction={"row"} spacing={0}>
                <DialogActions>
                    <IconButton  onClick={handleConfirmShowMe} color="primary">
                        <VisibilityIcon/>
                    </IconButton>
                </DialogActions>
                <DialogContent>
                    <DialogContentText color="primary"      style={{cursor:'pointer'}} onClick={handleConfirmShowMe}  >
                        Show Me
                    </DialogContentText>
                </DialogContent>
                </Stack>
                <br/>
                <Button onClick={handleDialogueClose} color="error">
                    Cancel
                </Button>
            </Dialog>

        </Box>
            <Box sx={{flexGrow: 1}}/>
        </Stack>
    );

    // ****************** END RETURN ****************************

}